import { Card, CardActionArea, CardContent, CardMedia, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';

import { IActionForProvider } from '../../../Lib/Actions/actions';
import PopupAppBar from '../../Common/PopupAppBar';
import { ITileLayerInfo } from '../../MapComponents/layers';

import uiStyles from "../../../Lib/UI/UI.module.css";


interface ChangeLayerPopupProps {
    action: IActionForProvider<void, ITileLayerInfo>;
    layers: ITileLayerInfo[];
    currentLayer?: ITileLayerInfo | null;
}

const ChangeLayerPopup = (props: ChangeLayerPopupProps): JSX.Element => {

    const handleSelection = (layer: ITileLayerInfo) => {
        props.action.complete(layer);
    };

    return (        
      <Dialog
          fullScreen
          open={props.action.isActive}
          onClose={props.action.cancel}
      >
        <PopupAppBar title="Select a Layer" icon={<MapIcon/>} onClose={props.action.cancel} />

        <DialogContent>

            <Stack 
              direction="row" 
              spacing={2}
              useFlexGap
              sx={{ flexWrap: 'wrap' }}
            >

            {props.layers.map((item, _idx) =>

                <Card key={item.id} sx={{ minWidth: '20%', width: '300px', maxWidth: '100%' }} className={props.currentLayer?.id === item.id ? uiStyles.card_selected : ''}>
                    <CardActionArea onClick={() => handleSelection(item)}>
                        <CardMedia
                            sx={{ height: 250 }}
                            image={item.thumbUrl}
                            title={item.name}
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h6" component="div">{item.name}</Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>

            )}

            </Stack>

        </DialogContent>

      </Dialog>
    );
};

export default ChangeLayerPopup;